import { useLDFlags } from './useLDFlags';

const enabled = ['guest', 'member', 'neither'];

export function usePdpSingleCTAFlag() {
  const { 'experiment-pdp-single-cta': pdpSingleCTAFlag } = useLDFlags();

  return {
    enabled: enabled.includes(pdpSingleCTAFlag) ? pdpSingleCTAFlag : false,
    value: pdpSingleCTAFlag,
  };
}
